import React from 'react'
import styled from 'styled-components'
import LegacyButton from 'components/LegacyButton'
import { appliedFiltersFriendlyNames } from 'pages/Customers/CustomerSearch/filterGroups'

import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { color } from 'styles/colors'
import { friendlyName } from 'helpers/formatters'

type Props = {
  selectedFilters: string[];
  clearAllFiltersCallback: () => void;
  removeFilterCallback: (selectedFilter: string) => void;
}

const SelectedFilterList = ({ selectedFilters, clearAllFiltersCallback, removeFilterCallback }: Props) => {
  return (
    <S.SelectedFilters>
      <S.ClearAllFilterButton variant="link" onClick={clearAllFiltersCallback}>Clear All</S.ClearAllFilterButton>
      {selectedFilters.map(filter => (
        <S.ClearSelectedFilterButton key={filter} variant="link">
          <S.ButtonText>
            {friendlyName(filter, appliedFiltersFriendlyNames)}
            <HighlightOffIcon data-testid={filter} onClick={() => { removeFilterCallback(filter) }} />
          </S.ButtonText>
        </S.ClearSelectedFilterButton>
      ))}
    </S.SelectedFilters>
  )
}

export default SelectedFilterList

const S = {
  SelectedFilters: styled.div`
    display: flex;
    margin: 10px 10px 10px 0px;
    gap: 10px;
    flex-wrap: wrap;
  `,
  ClearAllFilterButton: styled(LegacyButton)`
    display: block;
    background-color: ${color('tooltipBorder')};
    border: 1px solid ${color('tooltipBorder')};
    border-radius: 20px;
    padding: 4px 6px;
    font-size: 14px;
    font-weight: 400;
    color: ${color('customerFilterButtonText')};
  `,
  ClearSelectedFilterButton: styled(LegacyButton)`
    display: block;
    border: 0.8px solid ${color('filterIcon')};
    border-radius: 20px;
    padding: 4px 6px;
    font-size: 14px;
    font-weight: 400;
  `,
  ButtonText: styled.div`
    display: flex;
    color: ${color('customerFilterText')};
    align-items: center;
    padding-left: 5px;
    gap: 5px;
  `
}
